import {css} from "@emotion/css";

import {designColors, designTokens} from "~/ui";

export const styles = {
  link: (color: string) => css`
    &.MuiTypography-root {
      color: ${color};
      text-decoration-color: ${color};
    }
  `,
  weight: (value: keyof typeof designTokens.fontWeight) => css`
    &.MuiLink-root {
      font-weight: ${designTokens.fontWeight[value]};
    }
  `,
  disabled: css`
    &.MuiTypography-root {
      color: ${designColors.grey_4};
      pointer-events: none;
      cursor: default;
    }
  `,
};
